// extracted by mini-css-extract-plugin
export default {"wrap":"fade-in-div_wrap__QwlOW","active":"fade-in-div_active__Lbysq"};